<template>
  <div class="com-content">
    <div class="personalCenter__content_info">
      <div
        class="personalCenter__info_mainCon"
        v-bind:class="{
          personalCenter__info_rewardCon: baseInfo.userIdentity === 1,
        }"
      >
        <div class="personalCenter__info_hd">
          <div class="personalCenter__info_hdPic">
            <div class="personalCenter__info_headShow">
              <img :src="setUserAvatar(level)" />
            </div>
          </div>
          <div class="personalCenter__info_txt">
            <div class="personalCenter__line">
              <div v-if="baseInfo.userIdentity !== 1" class="f-20 f-bold mr-10">
                {{ baseInfo.fullName || baseInfo.mobile }}
              </div>
              <div v-else class="f-14 mr-12 personalCenter__username">
                尊敬的：{{ baseInfo.fullName || baseInfo.mobile }}
              </div>
              <div v-if="detailedInfo.wechatOpenid" class="wechat-content">
                <img class="wechat-icon" src="../../assets/weixin.png" />
                <span class="userInfo--grey"
                  >微信号：<span class="wechat-nickname">{{
                    detailedInfo.nickName
                  }}</span></span
                >
                <span class="button--bindingsBth" @click="handleUnBundling"
                  >解绑</span
                >
              </div>
              <div v-else class="wechat-content">
                <img class="wechat-icon" src="../../assets/weixin.png" />
                <span class="txt--bindingsNo">未绑定</span>
                <span class="button--bindingsBth" @click="handleBinding"
                  >绑定</span
                >
              </div>
            </div>
            <div
              v-if="baseInfo.userIdentity === 1"
              class="personalCenter__line"
            >
              <div
                :class="`f-25 f-bold fc-t${level} personalCenter__memberTitle`"
              >
                {{ baseInfo.userLevel }}
              </div>
              <div
                v-if="level !== 4"
                class="f-14 personalCenter__memberMilestone member-bg-t1"
              >
                距离升级还差{{ baseInfo.validShipCount }}次出行
              </div>
              <div
                v-else
                class="f-14 personalCenter__memberMilestone member-bg-t1"
              >
                距离保级还差1次出行
              </div>
            </div>
            <div
              v-if="baseInfo.userIdentity === 1 && !isOverseaUser"
              class="personalCenter__line memberLink"
            >
              <a :href="rewardLink">进入皇家游享荟 &gt;</a>
            </div>
          </div>
        </div>
      </div>
      <div v-if="baseInfo.userIdentity === 1 && !isOverseaUser" class="personalCenter__reward">
        <div class="content">
          <div class="personalCenter__line">
            <span class="f-14 userInfo--grey">有效积分</span>
            <span class="f-25 f-bold fc-yellow js-reward-point">{{
              baseInfo.userPoint
            }}</span>
          </div>
          <div
            class="personalCenter__line reward-sign userInfo--grey"
            v-bind:class="{ 'not-sign': !memberIsSignIn }"
            @click="signIn"
          >
            <img
              v-if="memberIsSignIn"
              class="reward-sign-image"
              src="https://resource.rcclchina.com.cn/memberCenter/pc/reward_has_sigin.png"
            />
            <img
              v-else
              class="reward-sign-image"
              src="https://resource.rcclchina.com.cn/memberCenter/pc/reward_sigin.png"
            />
            <span
              class="f-14 align-middle"
              v-bind:class="{ 'fc-yellow': !memberIsSignIn }"
              >签到领积分</span
            >
          </div>
          <div v-if="baseInfo.infoIntegrity < 100" class="personalCenter__line">
            <img
              class="reward-editInfo-image"
              src="https://resource.rcclchina.com.cn/memberCenter/pc/editInfo.png"
            />
            <router-link
              to="/Rccl.UserCenter/CustomerInfo/EditInfo"
              class="f-14 fc-yellow fc-link-blue"
              >完善信息领200积分</router-link
            >
          </div>
        </div>
      </div>
      <div class="personalCenter_rightCon userInfo--grey f-14">
        <div class="content">
          <div class="suggestionInfo" @click="putSuggestion">
            <img
              src="https://resource.rcclchina.com.cn/memberCenter/pc/suggest.png"
            />
            <span class="align-middle">意见建议</span>
          </div>
          <a
            tag="div"
            class="casInfo"
            href="/cas/benefits"
            v-if="detailedInfo.loyaltyId && detailedInfo.loyaltyId.length > 0"
            target="_blank"
          >
            <img
              src="https://resource.rcclchina.com.cn/memberCenter/pc/cas.png"
            />
            <span class="align-middle">查看里程</span>
          </a>
          <router-link
            tag="div"
            class="couponInfo"
            to="/Rccl.UserCenter/UserCoupon/UserCoupon"
          >
            <img
              src="https://resource.rcclchina.com.cn/memberCenter/pc/coupon.png"
            />
            <span class="align-middle"
              >优惠券
              <span class="canUseCount">{{
                detailedInfo.noUsedCouponCount || 0
              }}</span>
              张</span
            >
          </router-link>
        </div>
      </div>
    </div>

    <!-- banner -->
    <div
      v-if="baseInfo.userIdentity == 0 && !isOverseaUser"
      class="personalCenter__reward-banner"
    >
      <router-link :to="signUpRewardLink"
        ><img
          src="https://resource.rcclchina.com.cn/memberCenter/pc/siginReward.jpg"
      /></router-link>
    </div>

    <!-- 签到弹层 -->
    <sign-in
      ref="sign"
      :signInPoint="signInPoint"
      :isSignIn="picTip"
      @on-close="closeSignInTip"
    ></sign-in>

    <!-- 绑定微信 -->
    <bundling-wechat ref="bundling" @on-bind="checkBinding"></bundling-wechat>

    <!-- 解绑微信弹层 -->
    <un-bind-confirm
      ref="confirm"
      @on-confirm="handleUnBindConfirm"
      @on-cancel="handleUnBindCancel"
    ></un-bind-confirm>

    <!-- suggestion -->
    <suggestion ref="suggestion"></suggestion>
  </div>
</template>

<script>
import api from "@/api";
import img_00 from "@/assets/loginLogo_00.png";
import img_01 from "@/assets/member_01.png";
import img_02 from "@/assets/member_02.png";
import img_03 from "@/assets/member_03.png";
import img_04 from "@/assets/member_04.png";
import BundlingWechat from "./BundlingWechat";
import UnBindConfirm from "./UnBindConfirm";
import SignIn from "./SignIn";
import Suggestion from "./Suggestion";

export default {
  name: "UserInfoCard",
  components: {
    BundlingWechat,
    UnBindConfirm,
    SignIn,
    Suggestion,
  },
  data() {
    return {
      token: "",
      baseInfo: {},
      detailedInfo: {},
      userIdentity: 0, // 是否为会员 0 非会员  1 会员
      level: 0, // 会员等级，数字
      memberIsSignIn: false, // 默认没签到
      picTip: false, // false未签到  true已签到
      isShowSuggestion: false,
      signInPoint: 1,
    };
  },
  beforeMount() {
    const userToken = this.$store.state.user.userToken;
    if (userToken && userToken.length > 0) {
      this.init();
    }
  },
  methods: {
    async init() {
      this.$loading.show();
      await this.initPage();
      this.$loading.hide();
    },
    async initPage() {
      const userToken = this.$store.state.user.userToken;
      this.token = userToken;

      await this.$store.dispatch("GET_USER_INFO", userToken);
      this.baseInfo = this.$store.state.user.userInfo;
      this.detailedInfo = await this.getInfo();

      this.level = this.checkIdentity(this.baseInfo);
      this.memberIsSignIn = this.detailedInfo.memberIsSignIn;
    },
    checkIdentity(userInfo) {
      if (userInfo.userIdentity !== 1) return 0;
      switch (userInfo.levelEN) {
        case "T1":
          return 1;
        case "T2":
          return 2;
        case "T3":
          return 3;
        case "T4":
          return 4;
      }
    },
    setUserAvatar(level) {
      switch (level) {
        case 0:
          return img_00;
        case 1:
          return img_01;
        case 2:
          return img_02;
        case 3:
          return img_03;
        case 4:
          return img_04;
      }
    },
    async signIn() {
      if (this.memberIsSignIn) {
        this.picTip = true;
        this.$refs["sign"].show();
        return false;
      }
      this.$loading.show();
      const { errMsg, data, success } = await api.user.signIn(this.token);
      this.$loading.hide();
      if (success) {
        this.$refs["sign"].show();
        this.memberIsSignIn = true;
        if (typeof data === "number" && data > 0) {
          this.signInPoint = data;
          this.baseInfo.userPoint += data;
        }
      } else {
        this.$alert.show(errMsg);
      }
    },
    closeSignInTip() {},
    handleUnBundling() {
      this.$refs["confirm"].show();
    },
    async handleUnBindConfirm() {
      this.$loading.show();
      await this.unBundlingWechat();
      this.$loading.hide();
      location.reload();
    },
    handleUnBindCancel() {},
    async handleBinding() {
      await this.$refs["bundling"].show();
    },
    checkBinding() {},
    putSuggestion() {
      this.$refs.suggestion.init();
    },
    async getInfo() {
      const { errMsg, data, success } = await api.user.getUserAllInfo();
      if (success) {
        return data;
      } else {
        window.console.log(errMsg);
      }
    },
    async unBundlingWechat() {
      const { errMsg, success } = await api.user.unBindWechat();
      if (success) {
        this.detailedInfo.wechatOpenid = "";
      } else {
        this.$message.show("error", errMsg);
      }
    },
  },
  computed: {
		userInfo () {
			return this.$store.state.user.userInfo;
		},
    signUpRewardLink() {
      if (typeof window != "undefined") {
        return (
          "/Rccl.UserCenter/CustomerInfo/SignUpReward?returnUrl=" +
          encodeURIComponent(location.href)
        );
      } else {
        return "/Rccl.UserCenter/CustomerInfo/SignUpReward?returnUrl=";
      }
    },
    rewardLink() {
      const userInfo = this.$store.state.user.userInfo;
      if (
        !userInfo ||
        !userInfo.localRewardToken ||
        userInfo.localRewardToken.length == 0
      ) {
        return "";
      }
      return `${process.env.VUE_APP_REWARD_URL}/rewardpc/member/index?token=${userInfo.localRewardToken}`;
    },
		isOverseaUser () {
			if (!this.userInfo || !this.userInfo.callingCode) {
				return false;
			}
      return this.userInfo != null && this.userInfo.callingCode != "86" && this.userInfo.callingCode != '+86';
    },
  },
};
</script>

<style lang="less" scoped>
/************************头像等信息************************/
.personalCenter__content_confirmInfo {
  position: relative;
}

.personalCenter__content_info {
  position: relative;
  height: 120px;
  background-color: white;
  padding: 10px 0px;
  margin-top: 20px;
  font-weight: 400;
}

.personalCenter__info-bg {
  position: absolute;
  width: 100%;
}

.personalCenter__info_mainCon {
  padding-left: 20px;
  display: inline-block;
  vertical-align: middle;
  height: 100%;
}

.personalCenter__info_rewardCon {
  width: 510px;
  border-right: 1px solid #e3e6ea;
}

.personalCenter__reward {
  display: inline-block;
  vertical-align: middle;
  width: 275px;
  height: 100%;
  padding-left: 25px;
}

.personalCenter__reward .content {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}

.personalCenter__reward .personalCenter__line {
  margin-bottom: 5px;
}

.personalCenter__reward .personalCenter__line img {
  margin-right: 8px;
}

.personalCenter__reward .personalCenter__line a {
  display: inline-block;
  vertical-align: middle;
}

.personalCenter__reward .personalCenter__line .js-reward-point {
  margin-left: 4px;
}

.personalCenter__reward .reward-sign.not-sign {
  cursor: pointer;
}

.canUseCount {
  margin-top: -2px;
  color: #ff3022;
}
.voucherCount {
  color: #ff3022;
}
.personalCenter__info_hd {
  position: relative;
  width: 100%;
  margin-top: 7px;
}

.personalCenter__info_hdPic {
  position: relative;
  display: inline-block;
}

.personalCenter__info_editBtn {
  position: absolute;
  top: 0px;
  right: 0px;
}

.personalCenter__info_txt {
  display: inline-block;
  vertical-align: middle;
  margin-left: 12px;
}

.personalCenter__info_txt p {
  margin: 0;
}

.personalCenter__memberMilestone {
  padding: 1px 13px;
  margin-left: 5px;
  border-radius: 11px;
  color: white;
}

.personalCenter__info_ft {
  margin-top: 23px;
  margin-left: 8px;
  position: relative;
}

.personalCenter__info_ft div {
  display: inline-block;
  margin: 0;
  font-size: 18px;
  vertical-align: middle;
}
.personalCenter_rightCon {
  position: relative;
  float: right;
  width: 150px;
  height: 100%;
  padding-left: 20px;
  border-left: 1px solid #e3e6ea;
}

.personalCenter_rightCon .content {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}

.personalCenter_rightCon .content > div {
  margin-bottom: 7px;
  color: #747d80;
}

.personalCenter_rightCon img {
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
}

.personalCenter_rightCon span {
  display: inline-block;
  vertical-align: middle;
}

.suggestionInfo {
  cursor: pointer;
}

.casInfo {
  cursor: pointer;
  color: #747d80;
  margin-bottom: 7px;
  display: block;
}

.couponInfo {
  cursor: pointer;
}

.personalCenter__reward-banner {
  margin-top: 10px;
  margin-bottom: 30px;
  cursor: pointer;
}

.memberName {
  font-size: 22px;
  vertical-align: middle;
}
.memberId {
  margin-top: 5px;
}
.personalCenter__info_ft .personalCenter__vipDegree {
  position: absolute;
  top: 50px;
  left: 110px;
  z-index: 999;
  background: #fff;
  box-shadow: 0px 1px 25px rgba(0, 0, 0, 0.1);
  padding: 16px 34px 28px 34px;
  border-radius: 6px;
  display: none;
}
.memberAndWeixin {
  margin-top: 2px;
}
.memberId {
  display: inline-block;
  margin-right: 15px;
}
.personalCenter__info_weixin {
  display: inline-block;
  /*margin-left: 15px;*/
}
.personalCenter__info_weixin div {
  display: inline-block;
}
.personalCenter__info_ftPics {
  display: inline-block;
  width: 25px;
}

.personalCenter__info_ftPics img {
  width: 100%;
}

#spanunbind {
  margin-left: 8px;
  color: #337ab7;
}

.personalCenter__info_ft .personalCenter__vipDegree .vipDegree__arrow {
  margin-top: 10px;
}

.personalCenter__info_ft .personalCenter__vipDegree div {
  display: inline-block;
  text-align: center;
  vertical-align: top;
}

.personalCenter__info_ft .personalCenter__vipDegree div p {
  margin: 0px;
  font-size: 14px;
  width: 56px;
}

.personalCenter__info_ft .personalCenter__vipDegree .txt--vipYellow {
  color: #d8a928;
}

.personalCenter__info_ft .personalCenter__vipDegree .txt--vipWhite {
  color: #c5c6c4;
}

.personalCenter__info_ft .personalCenter__vipDegree .txt--vipEmeralds {
  color: #45795e;
}

.personalCenter__info_ft .personalCenter__vipDegree .txt--vipDiamond {
  color: #68acc4;
}

.personalCenter__info_ft .personalCenter__vipDegree .txt--vipDiamondBig {
  color: #8d7ba6;
}

.personalCenter__info_ft .personalCenter__vipDegree .txt--vipClub {
  color: #125e9f;
}

.personalCenter__infoPic,
.personalCenter__creditInfo {
  width: 17px;
  height: 17px;
  cursor: pointer;
}

.personalCenter__info_ft span {
  font-size: 18px;
}

.personalCenter__info_ft .personalCenter__info_vipdegree,
.personalCenter__info_ft .personalCenter__info_mileMark,
.personalCenter__info_ft .personalCenter__info_weixin {
  margin-right: 74px;
}
.personalCenter__info_vipdegree {
  display: inline-block;
}
.member_title {
  position: relative;
}
.personalCenter__info_ft .personalCenter__info_ftPics {
  width: 43px;
  height: 43px;
  margin-right: 14px;
}

.personalCenter__info_ft .txt--bindingsNo {
  color: #b6b6b6;
}

.button--bindingsBth {
  color: #0073bb;
  margin-left: 7px;
  cursor: pointer;
}

.personalCenter__info_ft .forMoreInfo,
.editProfile {
  color: #0072ff;
  margin-left: 19px;
  border-bottom: solid 1px;
  cursor: pointer;
  text-decoration: none;
}

.loginLink {
  color: #0072ff;
  border-bottom: solid 1px;
  cursor: pointer;
  text-decoration: none;
}

.forMoreInfo:hover,
.editProfile:hover,
.loginLink:hover {
  text-decoration: none !important;
  color: #0072ff !important;
}

.personalCenter__creditZero {
  width: 400px;
  position: absolute;
  top: 50px;
  left: 440px;
  z-index: 999;
  background: #fff;
  box-shadow: 0px 1px 25px rgba(0, 0, 0, 0.1);
  padding: 16px 34px 18px 34px;
  border-radius: 6px;
}

.personalCenter__creditZero p {
  font-size: 14px;
}

.personalCenter_canEdit {
  font-size: 16px;
  margin-top: 10px;
  margin-left: 70px;
}

.updateCasTips {
  color: #0073bb;
  text-decoration: underline;
  margin-top: 5px;
  cursor: pointer;
}

.personalCenter__line > div {
  display: inline-block;
  vertical-align: middle;
}
.wechat-content {
  .wechat-icon {
    display: inline-block;
    vertical-align: middle;
    width: 18px;
    margin: 0 5px;
  }
  span {
    display: inline-block;
    vertical-align: middle;
  }
  .wechat-nickname {
    vertical-align: initial;
  }
}
</style>
